import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useCustomerAddress, useUpdateCustomerAddress } from "../hooks";
import { CustomerAddressForm } from "../components";

type IUpdateCustomerAddress = {
  id: string;
};

export const UpdateCustomerAddress: React.FC = () => {
  const { id } = useParams<IUpdateCustomerAddress>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useCustomerAddress(+id!);
  const { form, submit, loading } = useUpdateCustomerAddress({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("L'adresse a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.customerAddress?.ok && data?.customerAddress?.result) {
      const { result } = data.customerAddress;
      form.setValue("customerId", result.customer?.id);
      form.setValue("type", result.type);
      form.setValue("label", result.label);
      form.setValue("street", result.street);
      form.setValue("city", result.city);
      form.setValue("postal", result.postal);
      form.setValue("isMain", result.isMain);
      form.setValue("active", result.active);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Adresse"
        subtitle={data?.customerAddress?.result?.label}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/customer-address/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une adresse" />
          <CustomerAddressForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
